'use client';

import { useContext } from 'react';
import { AppConfigContext } from '../provider/appConfigProvider';

export const useAppConfiguration = () => {
  const context = useContext(AppConfigContext);
  if (!context)
    throw new Error(
      'useAppConfiguration must be used within an AppConfigProvider',
    );

  const resertSettings = () => {
    document.cookie = 'alias=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;';
  };

  return { ...context, resertSettings };
};
